import React, {Component} from "react";
import Dialog from "@material-ui/core/Dialog";

class ClSuccessPage extends Component{
    constructor(props) {
        super(props);
        this.state = {
            successText:"Successfully Created New Credit Line!"
        }
    }

    render(){
        const {successText} = this.state;
        const {handleClickedOk} = this.props;
        return (
            <div>
                <Dialog open={true} aria-labelledby="responsive-dialog-title" maxWidth="lg" classes={{ paperWidthSm: "wider-dialoge" }}>
                    <div style={{ padding: "1em" }}>
                        <div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div style={{ color: "green" }}>{successText} </div>
                                </div>
                            </div>
                            <div className="row" style={{ paddingRight: "2em" }}>
                                <button className="btn btn-jt-ops pull-right" onClick={() => { handleClickedOk() }}>
                                    OK
                                </button>
                            </div>
                        </div>
                    </div>
                </Dialog>
            </div>
        );
    }
}

export default ClSuccessPage;



// WEBPACK FOOTER //
// ./src/screens/instantCredit/components/ClSuccessPage.js